// extracted by mini-css-extract-plugin
export default {"extraSmall":"Logo_extraSmall__SvRW6","small":"Logo_small__FS67d","medium":"Logo_medium__p0RlN","big":"Logo_big__6DomT"};